import { render, staticRenderFns } from "./CardImg.vue?vue&type=template&id=03649367&"
import script from "./CardImg.vue?vue&type=script&lang=js&"
export * from "./CardImg.vue?vue&type=script&lang=js&"
import style0 from "./CardImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports